module.exports = __webpack_public_path__ + "87bf0935d9d7361c65ab755f2abafbaf.pdf";